// import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import CommaPrice from "src/features/Utils/CommaPrice";
import get from "lodash/get";
import React from "react";

const getPrice = (item) =>
  get(item, "is_promo")
    ? get(item, "promo_price", 0) * get(item, "amount", 0)
    : get(item, "price", 0) * get(item, "amount", 0);

function PriceSummary(props) {
  // const theme = useTheme()
  const med_price = props.medicineCart.length
    ? props.medicineCart
        .map((item) => getPrice(item))
        .reduce((acc, crv) => acc + crv)
    : 0;
  const sup_price = props.supplyCart.length
    ? props.supplyCart
        .map((item) => getPrice(item))
        .reduce((acc, crv) => acc + crv)
    : 0;
  return (
    <>
      <Box fontSize="16px" fontWeight="bold" mb={0.9}>
        Cart summary
      </Box>
      <Box mt={1.5} display="flex" justifyContent="space-between">
        <Box>Subtotal:</Box>
        {CommaPrice(med_price + sup_price)}
      </Box>
      <Box mt={1.5} display="flex" justifyContent="space-between">
        <Box>Shipping Fee:</Box>
        <strong>Free</strong>
      </Box>
      <Box mt={2.2} display="flex" justifyContent="space-between">
        Grand total:
        <Box fontSize="16px" fontWeight="bold">
          {CommaPrice(med_price + sup_price)}
        </Box>
      </Box>
      <Box fontSize="12px" color="text.secondary" textAlign="right">
        This price incloud vat 7%
      </Box>
    </>
  );
}

export default PriceSummary;
